import React, { useState } from "react"
import { Link } from "gatsby"
import { twMerge } from "tailwind-merge"
import TicIconTrans from "../svg/tic/ticIconTrans"
import Tic from "../svg/tic/tic"
import { Bars3Icon } from "@heroicons/react/24/solid"
import { XMarkIcon } from "@heroicons/react/20/solid"
import PopNav from "../el/popnav"
import Search from "./search"
import CartButton from "./cartButton"
import ContactButton from "./contactButton"
import ProductNavButton from "../el/productnavbutton"
const NavBar = () => {
  // const [userOpen, setUserOpen] = useState(false)

  const [mobileMenu, setMobileMenu] = useState(false)

  return (
    <nav className="z-30 bg-white shadow">
      <div className="main-wrap mx-auto max-w-7xl px-2 sm:px-4 lg:px-8">
        <div className="flex h-16 justify-between">
          <div className="flex px-2 lg:px-0">
            <div className="flex shrink-0 items-center">
              <Link to="/">
                <TicIconTrans className="block h-8 w-auto fill-current text-blue-800 lg:hidden" />
                <Tic
                  className={twMerge([
                    "hidden h-8 w-auto lg:block",
                    "ticStandard",
                  ])}
                />
                <span className="sr-only">Thomson Home</span>
              </Link>
            </div>

            {/* Start Products link */}
            <ProductNavButton />
            {/* END products link */}

            <div className="hidden lg:ml-6 lg:flex">
              <NavLink to="/cellculture">Cell Culture Solutions</NavLink>
              <NavLink to="/analytical">Analytical Solutions</NavLink>
              <NavLink to="/an">Technical Resources</NavLink>
            </div>
          </div>

          <Search />

          <div className="flex items-center lg:hidden">
            <ContactButton />
            <CartButton />
            {/* <!-- Mobile menu button --> */}
            <button
              className="inline-flex items-center justify-center rounded-md p-2 text-slate-400 transition hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 focus:outline-none"
              aria-label="Main menu"
              aria-expanded="false"
              onClick={() => setMobileMenu(!mobileMenu)}
            >
              {/* Icon when menu is closed.  */}
              <Bars3Icon
                className={`${
                  mobileMenu ? `hidden` : `block`
                } h-6 w-6 stroke-current`}
              ></Bars3Icon>
              {/* //Icon when menu is open.  */}
              <XMarkIcon
                className={`${
                  !mobileMenu ? `hidden` : `block`
                } h-6 w-6 stroke-current`}
              ></XMarkIcon>
            </button>
          </div>
          <div className="hidden lg:ml-1 lg:flex lg:items-center">
            <ContactButton />
            <CartButton />
          </div>
        </div>
      </div>

      {/* Mobile menu, toggle classes based on menu state.
    Menu open: "block", Menu closed: "hidden" */}

      <div className={`${mobileMenu ? `block` : `hidden`} lg:hidden`}>
        <div className="pb-3 pt-2">
          <NavLinkMobile to="/cellculture">
            Cell Culture Solutions
          </NavLinkMobile>
          <NavLinkMobile to="/analytical">Analytical Solutions</NavLinkMobile>
          <NavLinkMobile to="/an">Technical Resources</NavLinkMobile>
          <NavLinkMobile to="/legal/careers">Careers</NavLinkMobile>
        </div>
        <div className="border-t border-slate-200 px-2 pb-3 pl-4 pt-4">
          <PopNav></PopNav>
        </div>
      </div>
    </nav>
  )
}

const NavLink = props => {
  return (
    <Link
      to={props.to}
      className={twMerge([
        "ml-8 inline-flex items-center border-b-2 border-transparent px-1 pt-1 text-sm font-medium leading-5 text-slate-500 transition first-of-type:ml-0 hover:border-slate-300 hover:text-slate-700 focus:border-slate-300 focus:text-slate-700 focus:outline-none",
        props.className,
      ])}
      activeClassName="!border-blue-500 focus:!border-blue-700"
    >
      {props.children}
    </Link>
  )
}

const NavLinkMobile = props => {
  return (
    <Link
      to={props.to}
      className={twMerge([
        "mt-1 block border-l-4 border-transparent py-2 pl-3 pr-4 text-base font-medium text-slate-600 transition first-of-type:mt-0 hover:border-slate-300 hover:bg-slate-500 hover:text-slate-800 focus:border-slate-300 focus:bg-slate-500 focus:text-slate-800 focus:outline-none",
        props.className,
      ])}
      activeClassName="border-blue-500 text-blue-700 bg-blue-100 focus:text-blue-800 focus:bg-blue-100 focus:border-blue-700"
    >
      {props.children}
    </Link>
  )
}

export default NavBar
